import styled from 'styled-components';
import { Layout } from 'antd';

export const Container = styled(Layout)`
  min-height: 100vh;
  max-width: 100%;

  > .ant-layout-content {
    padding: 30px;
  }
`;

//  height: 100%;
// display: flex;
// justify-content: center;
// align-items: center;
// background: #006da3;
